import Joi from 'joi';

/**
 * Schema for operator user settings updates.
 */
export const updateUserSettingsSchema = () =>
  Joi.object({
    languageId: Joi.number().integer().allow(null).messages({
      'number.base': 'validations|user-settings-language-id|must-be-number',
    }),
    timezone: Joi.string().allow(null).messages({
      'string.base': 'validations|user-settings-timezone|must-be-string',
    }),
  }).unknown();
